import { makeStyles } from "@mui/styles";
import { BaseThemeOptions } from "themes/base";

export const useStyles = makeStyles((theme: BaseThemeOptions) => ({
	uploaderContainer: {
		display: "flex",
		width: "100%",
		height: "calc(100% - 70px)",
		overflow: "hidden",
	},

	uploaderContent: {
		display: "flex",
		flexDirection: "column",
		width: "100%",
		height: "100%",
	},
	uploaderMainContent: {
		display: "flex",
		justifyContent: "center",
		width: "calc(100% - 32px)",
		height: "100%",
		margin: "16px",
		"&.onUpload": {
			margin: "16px 16px 83px",
		},
	},
	errorsTableContainer: {
		height: "100%",
		"& div": {
			boxShadow: "none !important",
		},
	},

	configUploaderModal: {
		display: "flex",
		height: "100%",
	},

	configUploaderMenuHeader: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		padding: "16px",
		width: "100%",
	},

	buttonFont: {
		fontWeight: "700",
		color: "white.main",
	},

	configUploaderSubModal: {
		width: "54vw",
	},

	selectorUploader: {
		display: "flex",
		justifyContent: "center",
		height: "100%",
		flexDirection: "column",
	},

	selectorUploader2: {
		display: "flex",
		justifyContent: "center",
		height: "100%",
	},

	reUploadButton: {
		padding: "10px",
	},

	radioLabel: {
		alignItems: "flex-start",
	},

	radioLabelMargin: {
		alignItems: "flex-start",
		marginBottom: "8px",
	},

	radioDescription: {
		fontSize: "0.8rem",
		marginTop: "2px",
	},
}));
